import { Attr, BelongsTo, Model } from "spraypaint";

import type { FeatureId } from "shared/helpers/features";
import { ApplicationRecord } from "shared/services/spraypaint";

import type Invoice from "./Invoice";
import type { InvoiceLedger, InvoiceStatus } from "./types";

@Model()
class InvoiceLineItem extends ApplicationRecord {
  static jsonapiType = "invoice_line_items";

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) description: string;

  @Attr({ persist: false }) feature: FeatureId;

  @BelongsTo() invoice: Invoice;

  @Attr({ persist: false }) ledger: InvoiceLedger;

  @Attr() status: InvoiceStatus;

  @Attr({ persist: false }) unitCost: number;

  @Attr({ persist: false }) units: number;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() writeOffReason: string;
}

export default InvoiceLineItem;
